import React, { Component } from 'react';
import { Link, withRouter, NavLink } from 'react-router-dom';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Modal,
  Badge,
  Button,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Icon } from 'react-fa';
import { LinkContainer } from 'react-router-bootstrap';
import { Loader } from '../Loader';
import { cancelOrder, externalSite } from '../../actions/auth';
import { uploadUserData, getSearchMode } from '../../modules/common';
import moment from 'moment';
import LogoutModal from './LogoutModal';
import { toast } from 'react-toastify';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSyncModal: false,
      isSyncing: false,
      cancel: false,
    };
    this.handleExternalSite = this.handleExternalSite.bind(this);
    this.selectSearchMode = this.selectSearchMode.bind(this);
    this.handleSyncNow = this.handleSyncNow.bind(this);
    this.toggleSyncModal = this.toggleSyncModal.bind(this);
  }
  async handleLogout() {
    const { auth, userData } = this.props;
    try {
      await uploadUserData(auth.user, userData, true);
    } catch (error) {
      console.error('Logout sync failed:', error);
    }
  }
  handleLoginNameDisplay() {
    const { forms, dispatch } = this.props;
    dispatch(
      actions.change(
        'forms.global.loginNameDisplay',
        !forms.global.loginNameDisplay
      )
    );
  }
  handleCancelOrder() {
    if (!this.state.cancel) {
      this.setState({ cancel: true });
    } else {
      this.props.dispatch(cancelOrder());
      this.setState({ cancel: false });
    }
  }
  handleCancelOrderBack() {
    this.setState({ cancel: false });
  }
  selectSearchMode(mode) {
    const { dispatch } = this.props;
    dispatch(actions.change('forms.global.searchMode', mode.toString()));
    dispatch(actions.change('forms.global.updateDate', moment().format()));
  }
  handleExternalSite(url, blank) {
    const { dispatch } = this.props;
    dispatch(externalSite({ url: url, blank: blank }));
  }
  handlelog(url, blank) {
    const { dispatch, showUploadWarning } = this.props;
    if (showUploadWarning) {
      this.toggleSyncModal(true);
    } else {
      dispatch(externalSite({ url: url, blank: blank }));
    }
  }

  toggleSyncModal(show) {
    this.setState({ showSyncModal: show });
  }

  handleSyncNow = async () => {
    this.setState({ isSyncing: true });
    try {
      const { auth, userData } = this.props;
      await uploadUserData(auth.user, userData);
      toast.success('データの同期を試みました。');
      this.toggleSyncModal(false);
    } catch (error) {
      console.error('Manual sync failed:', error);
    } finally {
      this.setState({ isSyncing: false });
    }
  };

  render() {
    const { global, forms, auth, year, location } = this.props;
    let loginButtonFlag = true;

    if (location.pathname) {
      loginButtonFlag =
        (location.pathname.match(/exam/) || location.pathname.match(/login/)) ==
        null;
    }
    if (!global) {
      return <Loader fullPage text="データ取得中" />;
    }
    let searchModeList = getSearchMode();
    let strMode = global.searchMode[forms.global.searchMode].label;
    const purchaseButtonFlag =
      year.data && (year.data.earlyFlag || year.data.buyFlag);
    const purchaseButtonDisabledFlag = year.data && year.data.buyDisabledFlag;
    return (
      <header>
        <Navbar inverse collapseOnSelect fluid style={{ marginBottom: '0' }}>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/">{global.appName}</Link>
              <span
                className="visible-xs contents-title"
                style={{ fontSize: '90%' }}
              >
                {forms.layout.title}
              </span>
            </Navbar.Brand>

            <Navbar.Toggle />
            <span
              className="hidden-lg hidden-sm hidden-md"
              style={{ float: 'right' }}
            >
              <Navbar.Brand>
                {auth.user ? (
                  <NavDropdown
                    eventKey={5}
                    style={{ fontSize: 'inherit' }}
                    title={
                      <span style={{ fontSize: '12px' }}>
                        <Icon name="user" />{' '}
                        {forms.global.loginNameDisplay == null ||
                        forms.global.loginNameDisplay ? (
                          <span>
                            {auth.user.name_last} {auth.user.name_first}
                          </span>
                        ) : (
                          <span>ログイン中</span>
                        )}
                        {this.props.showUploadWarning && (
                          <Icon
                            name="exclamation-triangle"
                            style={{
                              marginLeft: 5,
                              lineHeight: '15px',
                              color: '#fbbc05',
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.toggleSyncModal(true);
                            }}
                          />
                        )}
                      </span>
                    }
                    id="basic-nav-dropwdown4"
                  >
                    <LinkContainer to="/mypage/orderlist">
                      <MenuItem eventKey={3.3}>
                        <Icon name="list" />
                        購入履歴
                      </MenuItem>
                    </LinkContainer>
                    <LinkContainer to="/mypage/edit">
                      <MenuItem eventKey={5.2}>
                        <Icon name="edit" />
                        登録情報の変更
                      </MenuItem>
                    </LinkContainer>
                    <LinkContainer to="/mypage/password">
                      <MenuItem eventKey={5.3}>
                        <Icon name="key" />
                        パスワードの変更
                      </MenuItem>
                    </LinkContainer>
                    <MenuItem
                      eventKey={5.4}
                      onSelect={this.handleLoginNameDisplay.bind(this)}
                    >
                      {forms.global.loginNameDisplay == null ||
                      forms.global.loginNameDisplay ? (
                        <span>
                          <Icon name="eye-slash" />
                          ログイン名の非表示
                        </span>
                      ) : (
                        <span>
                          <Icon name="eye" />
                          ログイン名の表示
                        </span>
                      )}
                    </MenuItem>
                    <MenuItem
                      eventKey={5.1}
                      onSelect={this.handleLogout.bind(this)}
                    >
                      <Icon name="sign-out" />
                      ログアウト
                    </MenuItem>
                    {false &&
                      auth.user.order &&
                      moment(auth.user.order.create_date)
                        .add(auth.user.system.cancel_permit_term, 'days')
                        .isAfter(moment()) && (
                        <MenuItem
                          eventKey={5.2}
                          onSelect={this.handleCancelOrder.bind(this)}
                        >
                          <Icon name="ban" />
                          クーリングオフ
                        </MenuItem>
                      )}
                  </NavDropdown>
                ) : (
                  <React.Fragment>
                    {loginButtonFlag && (
                      <Link
                        to="/mypage/"
                        style={{
                          fontSize: 'inherit',
                          marginLeft: purchaseButtonFlag ? 4 : 0,
                        }}
                      >
                        <Button bsStyle="warning" style={{ borderRadius: 17 }}>
                          <Icon name="user" style={{ lineHeight: '15px' }} />
                          ログイン
                        </Button>
                      </Link>
                    )}

                    {purchaseButtonFlag &&
                      (purchaseButtonDisabledFlag ? (
                        <Button
                          bsStyle="warning"
                          disabled
                          className="btn"
                          style={{
                            borderRadius: 17,
                            paddingLeft: 15,
                            paddingRight: 15,
                          }}
                        >
                          <Icon
                            name="shopping-cart"
                            style={{ lineHeight: '15px' }}
                          />
                          購入
                        </Button>
                      ) : (
                        <Link
                          to="/order/"
                          style={{ fontSize: 'inherit' }}
                          className="btn"
                        >
                          <Button
                            bsStyle="warning"
                            style={{
                              borderRadius: 17,
                              paddingLeft: 15,
                              paddingRight: 15,
                            }}
                          >
                            <Icon name="user" style={{ lineHeight: '15px' }} />
                            購入
                          </Button>
                        </Link>
                      ))}
                  </React.Fragment>
                )}
              </Navbar.Brand>
            </span>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <LinkContainer to="/standard">
                <NavItem eventKey={1}>学ぶ</NavItem>
              </LinkContainer>
              <LinkContainer to="/resolve">
                <NavItem eventKey={2}>解く</NavItem>
              </LinkContainer>
              <LinkContainer to="/other">
                <NavItem eventKey={5}>進捗</NavItem>
              </LinkContainer>
              <NavDropdown eventKey={3} title="その他" id="basic-nav-dropdown">
                <LinkContainer to="/other/setting">
                  <MenuItem eventKey={3.3}>
                    <Icon name="gear" />
                    設定
                  </MenuItem>
                </LinkContainer>

                {auth.user ? (
                  year.data && year.data.downloadLinkFlag ? (
                    <MenuItem
                      target="_blank"
                      onClick={() =>
                        this.handleExternalSite(
                          global.siteUrl + '/downloads/',
                          true
                        )
                      }
                      eventKey={3.4}
                    >
                      <Icon name="download" />
                      ダウンロード
                    </MenuItem>
                  ) : (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="overload-top">
                          本年度の利用は終了しました
                        </Tooltip>
                      }
                    >
                      <MenuItem disabled={true} eventKey={3.5}>
                        <Icon name="download" />
                        ダウンロード
                      </MenuItem>
                    </OverlayTrigger>
                  )
                ) : (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="overload-top">
                        購入後、ログインすると利用できます
                      </Tooltip>
                    }
                  >
                    <MenuItem disabled={true} eventKey={3.5}>
                      <Icon name="download" />
                      ダウンロード
                    </MenuItem>
                  </OverlayTrigger>
                )}
                {auth.user ? (
                  year.data && year.data.movieLinkFlag ? (
                    <MenuItem
                      onClick={() =>
                        this.handleExternalSite(
                          global.siteUrl + '/online',
                          true
                        )
                      }
                      disabled={auth.user ? false : true}
                      eventKey={3.5}
                    >
                      <Icon name="film" />
                      オンライン講義
                    </MenuItem>
                  ) : (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="overload-top">
                          本年度の利用は終了しました
                        </Tooltip>
                      }
                    >
                      <MenuItem disabled={true} eventKey={3.5}>
                        <Icon name="film" />
                        オンライン講義
                      </MenuItem>
                    </OverlayTrigger>
                  )
                ) : (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="overload-top">
                        購入後、ログインすると利用できます
                      </Tooltip>
                    }
                  >
                    <MenuItem disabled={true} eventKey={3.5}>
                      <Icon name="film" />
                      オンライン講義
                    </MenuItem>
                  </OverlayTrigger>
                )}

                <LinkContainer to="/other/prediction">
                  <MenuItem eventKey={3.2}>
                    <Icon name="line-chart" />
                    学習計画
                  </MenuItem>
                </LinkContainer>

                {year.data.focusmodeLinkFlag ? (
                  <LinkContainer to="/focusmode">
                    <MenuItem eventKey={3.2}>
                      <Icon name="eye-slash" />
                      フォーカスモード
                    </MenuItem>
                  </LinkContainer>
                ) : (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="overload-top">現在利用できません</Tooltip>
                    }
                  >
                    <MenuItem disabled={true} eventKey={3.5}>
                      <Icon name="eye-slash" />
                      フォーカスモード
                    </MenuItem>
                  </OverlayTrigger>
                )}
                <MenuItem
                  onClick={() => this.handleExternalSite(global.faqUrl, true)}
                  eventKey={3.7}
                >
                  <Icon name="info-circle" />
                  FAQ
                </MenuItem>
                <LinkContainer to="/mypage/inquiry">
                  <MenuItem eventKey={3.6}>
                    <Icon name="question-circle" />
                    お問い合わせ
                  </MenuItem>
                </LinkContainer>
                {false && (
                  <LinkContainer to="/other/tradelaw">
                    <MenuItem eventKey={3.6}>
                      <Icon name="exclamation-circle" />
                      特定商取引に関わる表示
                    </MenuItem>
                  </LinkContainer>
                )}
                {year.data && year.data.guideUrl && (
                  <React.Fragment>
                    <MenuItem divider />
                    <MenuItem
                      onClick={() =>
                        this.handleExternalSite(year.data.guideUrl, true)
                      }
                      eventKey={3.4}
                    >
                      <Icon name="globe" />
                      合格ロケット活用法
                    </MenuItem>
                  </React.Fragment>
                )}
              </NavDropdown>
            </Nav>
            <Nav pullRight>
              <NavDropdown
                eventKey={4}
                title={`現在のモード:${strMode}`}
                id="basic-nav-dropdown2"
              >
                {searchModeList.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      onSelect={() => this.selectSearchMode(index)}
                    >
                      {item}
                    </MenuItem>
                  );
                })}
              </NavDropdown>
            </Nav>
            <span className="hidden-xs">
              <Nav pullRight>
                {auth.user ? (
                  <NavDropdown
                    eventKey={5}
                    title={
                      <span>
                        <Icon name="user" />
                        {forms.global.loginNameDisplay == null ||
                        forms.global.loginNameDisplay ? (
                          <span>
                            {auth.user.name_last} {auth.user.name_first}
                          </span>
                        ) : (
                          <span>ログイン中</span>
                        )}
                        {this.props.showUploadWarning && (
                          <Icon
                            name="exclamation-triangle"
                            style={{
                              marginLeft: 5,
                              lineHeight: '15px',
                              color: '#fbbc05',
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.toggleSyncModal(true);
                            }}
                          />
                        )}
                      </span>
                    }
                    id="basic-nav-dropwdown3"
                  >
                    <LinkContainer to="/mypage/orderlist">
                      <MenuItem eventKey={3.3}>
                        <Icon name="list" />
                        購入履歴
                      </MenuItem>
                    </LinkContainer>
                    <LinkContainer to="/mypage/edit">
                      <MenuItem eventKey={5.2}>
                        <Icon name="edit" />
                        登録情報の変更
                      </MenuItem>
                    </LinkContainer>
                    <LinkContainer to="/mypage/password">
                      <MenuItem eventKey={5.3}>
                        <Icon name="key" />
                        パスワードの変更
                      </MenuItem>
                    </LinkContainer>
                    <MenuItem
                      eventKey={5.4}
                      onSelect={this.handleLoginNameDisplay.bind(this)}
                    >
                      {forms.global.loginNameDisplay == null ||
                      forms.global.loginNameDisplay ? (
                        <span>
                          <Icon name="eye-slash" />
                          ログイン名の非表示
                        </span>
                      ) : (
                        <span>
                          <Icon name="eye" />
                          ログイン名の表示
                        </span>
                      )}
                    </MenuItem>
                    <MenuItem
                      eventKey={5.1}
                      onSelect={this.handleLogout.bind(this)}
                    >
                      <Icon name="sign-out" />
                      ログアウト
                    </MenuItem>
                    {false &&
                      auth.user.order &&
                      moment(auth.user.order.create_date)
                        .add(auth.user.system.cancel_permit_term, 'days')
                        .isAfter(moment()) && (
                        <MenuItem
                          eventKey={5.2}
                          onSelect={this.handleCancelOrder.bind(this)}
                        >
                          <Icon name="ban" />
                          クーリングオフ
                        </MenuItem>
                      )}
                  </NavDropdown>
                ) : (
                  <React.Fragment>
                    <ButtonGroup>
                      {loginButtonFlag && (
                        <LinkContainer to="/mypage/" className="btn">
                          <NavItem eventKey={6}>
                            <Button
                              bsStyle="warning"
                              style={{ borderRadius: 17 }}
                            >
                              <Icon name="user" />
                              ログイン
                            </Button>
                          </NavItem>
                        </LinkContainer>
                      )}
                      {purchaseButtonFlag &&
                        (purchaseButtonDisabledFlag ? (
                          <NavItem eventKey={5} className="btn">
                            <Button
                              bsStyle="warning"
                              className="btn"
                              disabled
                              style={{
                                borderRadius: 17,
                                paddingLeft: 25,
                                paddingRight: 25,
                              }}
                            >
                              <Icon name="user" />
                              購入
                            </Button>
                          </NavItem>
                        ) : (
                          <LinkContainer to="/order/" className="btn">
                            <NavItem eventKey={5}>
                              <Button
                                bsStyle="warning"
                                style={{
                                  borderRadius: 17,
                                  paddingLeft: 25,
                                  paddingRight: 25,
                                }}
                              >
                                <Icon name="user" />
                                購入
                              </Button>
                            </NavItem>
                          </LinkContainer>
                        ))}
                    </ButtonGroup>
                  </React.Fragment>
                )}
              </Nav>
            </span>
          </Navbar.Collapse>
        </Navbar>
        <LogoutModal />
        {this.state.cancel && (
          <div className="static-modal">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Title>クーリングオフ</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                クーリングオフを行います。この捜査は取り消しできません。よろしいですか？
              </Modal.Body>

              <Modal.Footer>
                <Button onClick={this.handleCancelOrderBack.bind(this)}>
                  キャンセル
                </Button>
                <Button
                  onClick={this.handleCancelOrder.bind(this)}
                  bsStyle="primary"
                >
                  クーリングオフ
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        )}
        {this.state.showSyncModal && (
          <div className="static-modal">
            <Modal
              show={this.state.showSyncModal}
              onHide={() => this.toggleSyncModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>データ同期の確認</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  サーバーへの学習履歴等が10分以上、記録保存されていません。
                </p>
                <p>今すぐデータを同期しますか？</p>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.toggleSyncModal(false)}>
                  キャンセル
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={this.handleSyncNow}
                  disabled={this.state.isSyncing}
                >
                  {this.state.isSyncing ? '同期中...' : '同期する'}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </header>
    );
  }
}

export default withRouter(connect((s) => s)(Header));



// WEBPACK FOOTER //
// ./src/components/layout/Header.js